type IconProps = {
  className?: string;
};

export const ToolsIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 100 100"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M56.4 45.1l-4.3 4.1 14 13.4 1.2-1.2 21.5-20.5-14-13.4-4.3 4.1-14.9-14.1 4.3-4.1L45.9 0 23.1 21.6l14 13.4 1.2-1.2 3.1-3 1.9 1.8L0 74l11.2 10.6 1.2-1.2 42.2-40.2 1.8 1.9zM72.9 34l1.9-1.8 9.1 8.7-17.8 17-9.1-8.7 1.9-1.8 1.2-1.2L72.9 34zM68 34l-9.1 8.7-1.9-1.8-11.1-10.6-1.9-1.8 9.1-8.7L68 34zm-28.9-5.5l-1.9 1.8-9.1-8.7L45.9 4.7l9.1 8.7-1.9 1.8-14 13.3zM11.2 79.9L4.9 74l40.9-39 3.1 3 3.1 3-40.8 38.9zm79.5 3.4V69.9H59.2v13.4h-9.3V100H100V83.3h-9.3zm-28-10.1h24.5v10H62.7v-10zm33.8 23.5H53.4v-10h43.1v10z" />
  </svg>
);
